module.exports = __webpack_public_path__ + "files/6aa6ffcd1980768921c743f94c15a703.svg";